import { createContext, useContext, FunctionComponent, ReactNode } from 'react';

type ServerVarsContextType = {
    isDesktop?: boolean;
    isMobile?: boolean;
    isTablet?: boolean;
};

export const ServerVarsContext = createContext<ServerVarsContextType>({});

export const ServerVarsContextConsumer = ServerVarsContext.Consumer;

type ServerVarsProviderProps = {
    children: ReactNode;
} & Required<ServerVarsContextType>;

export const ServerVarsContextProvider: FunctionComponent<ServerVarsProviderProps> = ({
    children,
    isDesktop,
    isMobile,
    isTablet,
}) => {
    return (
        <ServerVarsContext.Provider
            value={{
                isDesktop,
                isMobile,
                isTablet,
            }}
        >
            {children}
        </ServerVarsContext.Provider>
    );
};

export const useServerVarsContext = (): ServerVarsContextType => {
    return useContext(ServerVarsContext);
};
